import idx from 'idx'
import axios from 'axios'
import {normalize} from 'normalizr'
import {API_URL, SAUCE_API_URL} from 'config'

import initialState from 'reducers/initialState'
import {groupTrapSchema, userTrapSchema} from 'modules/schema'

import {LOCATION_CHANGE} from 'constants/actions'
import errorDispatcher from 'utils/errorDispatcher'
import {getQueryParams, getPaginationData, paginationFromCount} from 'utils/api'
import {getAuthorizationHeader} from 'utils/session'

import {MAP_CONTENT_CHANGED} from 'modules/map'
import {convertHistoryUuidToTrapUuid} from 'utils/misc'

// Actions
export const SELECT_TRAP = 'SELECT_TRAP'
export const API_GET_TRAP_SUCCESS = 'API_GET_TRAP_SUCCESS'
export const API_GET_TRAPS_REQUEST = 'API_GET_TRAPS_REQUEST'
export const API_GET_TRAPS_SUCCESS = 'API_GET_TRAPS_SUCCESS'
export const API_GET_TRAPS_ERROR = 'API_GET_TRAPS_ERROR'
export const API_GET_USER_TRAPS_REQUEST = 'API_GET_USER_TRAPS_REQUEST'
export const API_GET_USER_TRAPS_SUCCESS = 'API_GET_USER_TRAPS_SUCCESS'
export const API_GET_USER_TRAPS_ERROR = 'API_GET_USER_TRAPS_ERROR'
export const API_DELETE_TRAP_REQUEST = 'API_DELETE_TRAP_REQUEST'
export const API_DELETE_TRAP_SUCCESS = 'API_DELETE_TRAP_SUCCESS'
export const API_DELETE_TRAP_ERROR = 'API_DELETE_TRAP_ERROR'
export const API_REMOVE_TRAP_FROM_GROUP_REQUEST = 'API_REMOVE_TRAP_FROM_GROUP_REQUEST'
export const API_REMOVE_TRAP_FROM_GROUP_SUCCESS = 'API_REMOVE_TRAP_FROM_GROUP_SUCCESS'
export const API_REMOVE_TRAP_FROM_GROUP_ERROR = 'API_REMOVE_TRAP_FROM_GROUP_ERROR'
export const API_UPDATE_TRAP_REQUEST = 'API_UPDATE_TRAP_REQUEST'
export const API_UPDATE_TRAP_SUCCESS = 'API_UPDATE_TRAP_SUCCESS'
export const API_UPDATE_TRAP_ERROR = 'API_UPDATE_TRAP_ERROR'
export const API_GENERATE_TRAP_REPORT_REQUEST = 'API_GENERATE_TRAP_REPORT_REQUEST'
export const API_GENERATE_TRAP_REPORT_SUCCESS = 'API_GENERATE_TRAP_REPORT_SUCCESS'
export const API_GENERATE_TRAP_REPORT_ERROR = 'API_GENERATE_TRAP_REPORT_ERROR'
export const API_GENERATE_STRIKES_CSV_REPORT_REQUEST = 'API_GENERATE_STRIKES_CSV_REPORT_REQUEST'
export const API_GENERATE_STRIKES_CSV_REPORT_SUCCESS = 'API_GENERATE_STRIKES_CSV_REPORT_SUCCESS'
export const API_GENERATE_STRIKES_CSV_REPORT_ERROR = 'API_GENERATE_TRAP_REPORT_ERROR'
export const API_ASSIGN_TRAPS_REQUEST = 'API_ASSIGN_TRAPS_REQUEST'
export const API_ASSIGN_TRAPS_SUCCESS = 'API_ASSIGN_TRAPS_SUCCESS'
export const API_ASSIGN_TRAPS_ERROR = 'API_ASSIGN_TRAPS_ERROR'
export const API_TRANSFER_TRAPS_REQUEST = 'API_TRANSFER_TRAPS_REQUEST'
export const API_TRANSFER_TRAPS_SUCCESS = 'API_TRANSFER_TRAPS_SUCCESS'
export const API_TRANSFER_TRAPS_ERROR = 'API_TRANSFER_TRAPS_ERROR'
// TODO Think about moving all these trap/user access calls to their own file
export const API_INVITE_USER_TRAP_REQUEST = 'API_INVITE_USER_TRAP_REQUEST'
export const API_INVITE_USER_TRAP_SUCCESS = 'API_INVITE_USER_TRAP_SUCCESS'
export const API_INVITE_USER_TRAP_ERROR = 'API_INVITE_USER_TRAP_ERROR'
export const API_GET_INVITES_TRAP_REQUEST = 'API_GET_INVITES_TRAP_REQUEST'
export const API_GET_INVITES_TRAP_SUCCESS = 'API_GET_INVITES_TRAP_SUCCESS'
export const API_GET_INVITES_TRAP_ERROR = 'API_GET_INVITES_TRAP_ERROR'
export const API_REVOKE_TRAP_INVITE_REQUEST = 'API_REVOKE_TRAP_INVITE_REQUEST'
export const API_REVOKE_TRAP_INVITE_SUCCESS = 'API_REVOKE_TRAP_INVITE_SUCCESS'
export const API_REVOKE_TRAP_INVITE_ERROR = 'API_REVOKE_TRAP_INVITE_ERROR'
export const API_DELETE_USER_TRAP_REQUEST = 'API_DELETE_USER_TRAP_REQUEST'
export const API_DELETE_USER_TRAP_SUCCESS = 'API_DELETE_USER_TRAP_SUCCESS'
export const API_DELETE_USER_TRAP_ERROR = 'API_DELETE_USER_TRAP_ERROR'

// Reducer
export default function reducer(state = initialState.traps, action) {
    switch (action.type) {
        case LOCATION_CHANGE:
            return {
                ...state,
                items: null,
                selected: null,
            }
        case SELECT_TRAP:
            return {
                ...state,
                selected: action.trap
            }
        case API_GET_TRAPS_REQUEST:
            return {
                ...state,
                loading: true
            }
        case API_GET_USER_TRAPS_REQUEST:
            return {
                ...state,
                loading: true
            }
        case API_GET_TRAPS_SUCCESS:
            return {
                ...state,
                loading: false,
                items: action.traps
            }
        case API_GET_TRAP_SUCCESS:
            return {
                ...state,
                selected: action.trap
            }
        case API_GET_USER_TRAPS_SUCCESS:
            return {
                ...state,
                loading: false,
                userItems: action.traps
            }
        case API_UPDATE_TRAP_SUCCESS:
            return {
                ...state,
                items: {
                    ...state.items,
                    [action.uuid]: {
                        ...state.items[action.uuid],
                        ...action.trapUpdate.location,
                        trapName: action.trapUpdate.name
                    }
                }
            }
        default:
            return state
    }
}


export function selectTrap(trap, callback) {
    return function dispatcher(dispatch) {
        dispatch({type: SELECT_TRAP, trap})
        dispatch(() => callback())
    }
}

export function getReportTraps(organisation, filters, callback) {
    return async function dispatcher(dispatch) {
        dispatch({type: API_GET_TRAPS_REQUEST})
        try {
            const response = await axios.get(`${API_URL}/project/${organisation.uuid}/traps${getQueryParams('?', filters)}`, getAuthorizationHeader())
            const result = response.data.data
            if (!result) throw Error("no response data!")
            const pagination = paginationFromCount(response.data.total)

            const {entities: {traps}} = normalize(result, [groupTrapSchema])
            dispatch({type: API_GET_TRAPS_SUCCESS, traps: traps || {}})

            if (callback) {
                dispatch(() => callback(pagination))
            }
        }
        catch (error) {
            console.error("getReportTraps", error)
            const errorCode = idx(error, _ => _.response.status) || ''
            errorDispatcher(errorCode, API_GET_TRAPS_ERROR, dispatch)
        }
    }
}

export function getGroupTraps(organisation, group, filters, callback) {
    return async function dispatcher(dispatch) {
        dispatch({type: API_GET_TRAPS_REQUEST})

        const groupUuid = group.groupUuid || group.uuid

        try {
            const url = `${SAUCE_API_URL}/project/group/${groupUuid}/traps${getQueryParams('?', filters)}`
            const response = await axios.get(url, getAuthorizationHeader())
            const result = response.data.data
            if (!result) throw Error("no response data!")
            const pagination = paginationFromCount(response.data.total)

            if (response) {
                const {entities: {traps}} = normalize(result, [groupTrapSchema])
                dispatch({type: API_GET_TRAPS_SUCCESS, traps: traps || {}})

                if (callback) {
                    dispatch(() => callback(pagination))
                }
            }
            else {
                throw Error
            }
        }
        catch (error) {
            const errorCode = idx(error, _ => _.data.status) || ''
            errorDispatcher(errorCode, API_GET_TRAPS_ERROR, dispatch)
        }
    }
}

export function getUserTraps(user, organisation, filters, callback) {
    return async function dispatcher(dispatch) {
        dispatch({type: API_GET_USER_TRAPS_REQUEST})
        try {
            const response = await axios.get(
                `${API_URL}/project/${organisation.uuid}/user/${user.id}/traps${getQueryParams('?', filters)}`,
                getAuthorizationHeader()
            )
            const pagination = paginationFromCount(response.data.total)

            const {entities: {traps}} = normalize(response.data.data, [userTrapSchema])
            dispatch({type: API_GET_USER_TRAPS_SUCCESS, traps: traps || {}})

            if (callback) {
                dispatch(() => callback(pagination))
            }
        }
        catch (error) {
            const errorCode = idx(error, _ => _.data.status) || ''
            errorDispatcher(errorCode, API_GET_USER_TRAPS_ERROR, dispatch)
        }
    }
}

export function generateSummaryCsvReport(organisation, callback) {
    return async function dispatcher(dispatch) {
        dispatch({type: API_GENERATE_TRAP_REPORT_REQUEST})
        try {
            await axios.get(
                `${API_URL}/project/${organisation.uuid}/traps/csv?` + new URLSearchParams([["timeZoneName", Intl.DateTimeFormat().resolvedOptions().timeZone]]).toString(),
                getAuthorizationHeader()
            ).then((result) => {
                const reportData = idx(result, _ => _.data)
                dispatch({type: API_GENERATE_TRAP_REPORT_SUCCESS})
                if (callback) {
                    dispatch(() => callback(reportData))
                }
            }).catch((error) => {
                return Promise.reject(error.response)
            })
        }
        catch (error) {
            console.error("generateSummaryCsvReport", error)
            const errorCode = idx(error, _ => _.response.status) || ''
            errorDispatcher(errorCode, API_GENERATE_TRAP_REPORT_ERROR, dispatch)
        }
    }
}

export function generateStrikesCsvReport(organisation, callback) {
    return async function dispatcher(dispatch) {
        dispatch({type: API_GENERATE_STRIKES_CSV_REPORT_REQUEST})
        try {
            await axios.get(
                `${API_URL}/project/${organisation.uuid}/strikes/csv?` + new URLSearchParams([["timeZoneName", Intl.DateTimeFormat().resolvedOptions().timeZone]]).toString(),
                getAuthorizationHeader()
            ).then((result) => {
                const reportData = idx(result, _ => _.data)
                dispatch({type: API_GENERATE_STRIKES_CSV_REPORT_SUCCESS})
                if (callback) {
                    dispatch(() => callback(reportData))
                }
            }).catch((error) => {
                return Promise.reject(error.response)
            })
        }
        catch (error) {
            console.error("generateStrikesCsvReport", error)
            const errorCode = idx(error, _ => _.response.status) || ''
            errorDispatcher(errorCode, API_GENERATE_STRIKES_CSV_REPORT_ERROR, dispatch)
        }
    }
}

export function assignTrapsToGroup(organisation, traps, group, callback) {
    return async function dispatcher(dispatch, getState) {
        dispatch({type: API_ASSIGN_TRAPS_REQUEST})
        const allTraps = idx(getState(), _ => _.traps.items)
        const trapIds = convertHistoryUuidToTrapUuid(traps, allTraps)
        try {
            await axios.post(
                `${API_URL}/group/${group.uuid}/add-traps`,
                {trapIds},
                getAuthorizationHeader()
            )
            dispatch({type: API_ASSIGN_TRAPS_SUCCESS})
            if (callback) {
                dispatch(callback)
            }
        }
        catch (error) {
            console.error("assignTrapsToGroup", error)
            const errorCode = idx(error, _ => _.response.status) || ''
            errorDispatcher(errorCode, API_ASSIGN_TRAPS_ERROR, dispatch)
        }
    }
}

export function deleteTrap(organisation, trap, callback) {
    return async function dispatcher(dispatch) {
        dispatch({type: API_DELETE_TRAP_REQUEST})
        try {
            await axios.delete(
                `${SAUCE_API_URL}/organisation/${organisation.uuid}/trap/${trap.trapUuid}`,
                getAuthorizationHeader()
            ).then(() => {
                dispatch({type: API_DELETE_TRAP_SUCCESS})
                if (callback) {
                    dispatch(callback)
                }
            }).catch((error) => {
                return Promise.reject(error.response)
            })
        }
        catch (error) {
            const errorCode = idx(error, _ => _.data.status) || ''
            errorDispatcher(errorCode, API_DELETE_TRAP_ERROR, dispatch)
        }
    }
}

export function updateTrap(organisation, trap, trapUpdate, callback) {
    return async function dispatcher(dispatch) {
        dispatch({type: API_UPDATE_TRAP_REQUEST})
        try {
            await axios.post(
                `${API_URL}/traps/${trap.trapUuid}/update`,
                trapUpdate,
                getAuthorizationHeader()
            )
            dispatch({type: API_UPDATE_TRAP_SUCCESS, uuid: trap.trapUuid, trapUpdate})

            if (callback) {
                dispatch(callback)
            }

            if (trap.longitude !== trapUpdate.location.longitude || trap.latitude !== trapUpdate.location.latitude) {
                dispatch({type: MAP_CONTENT_CHANGED})
            }
        }
        catch (error) {
            console.error("updateTrap", error)
            const errorCode = idx(error, _ => _.response.status) || ''
            errorDispatcher(errorCode, API_UPDATE_TRAP_ERROR, dispatch)
        }
    }
}

export function removeTrapFromGroup(organisation, trap, callback) {
    return async function dispatcher(dispatch) {
        dispatch({type: API_REMOVE_TRAP_FROM_GROUP_REQUEST})
        try {
            await axios.post(
                `${API_URL}/traps/${trap.trapUuid}/remove-from-current-group`,
                {},
                getAuthorizationHeader()
            )
            dispatch({type: API_REMOVE_TRAP_FROM_GROUP_SUCCESS})
            if (callback) {
                dispatch(callback)
            }
        }
        catch (error) {
            console.error("removeTrapFromGroup", error)
            const errorCode = idx(error, _ => _.response.status) || ''
            errorDispatcher(errorCode, API_REMOVE_TRAP_FROM_GROUP_ERROR, dispatch)
        }
    }
}

export function transferTrapsToProject(traps, destinationOrg) {
    return async function dispatcher(dispatch, getState) {
        dispatch({type: API_TRANSFER_TRAPS_REQUEST})
        const allTraps = idx(getState(), _ => _.traps.items)
        const trapIds = convertHistoryUuidToTrapUuid(traps, allTraps)
        try {
            await axios.post(
                `${API_URL}/project/${destinationOrg}/add-traps`,
                {trapIds},
                getAuthorizationHeader()
            )
            dispatch({type: API_TRANSFER_TRAPS_SUCCESS})
            return true
        }
        catch (error) {
            console.error("transferTrapsToProject", error)
            const errorCode = idx(error, _ => _.response.status) || ''
            errorDispatcher(errorCode, API_TRANSFER_TRAPS_ERROR, dispatch)
            throw error
        }
    }
}

export function inviteUserTrap(email, trap) {
    return async function dispatcher(dispatch) {
        dispatch({type: API_INVITE_USER_TRAP_REQUEST})
        try {
            await axios.post(
                `${API_URL}/trap/share/${trap.trapUuid}?` + new URLSearchParams([["email", email]]).toString(),
                {},
                getAuthorizationHeader()
            )
            dispatch({type: API_INVITE_USER_TRAP_SUCCESS})
            return true
        }
        catch (error) {
            console.error("inviteUserTrap", error)
            const errorCode = idx(error, _ => _.response.data.status) || ''
            errorDispatcher(errorCode, API_INVITE_USER_TRAP_ERROR, dispatch)
            throw error
        }
    }
}

export function getInvitesTrap(inviteUuid) {
    return async function dispatcher(dispatch) {
        dispatch({type: API_GET_INVITES_TRAP_REQUEST})
        try {
            await axios.get(
                `${SAUCE_API_URL}/invites/${inviteUuid}?token=(base64-email)`,
                getAuthorizationHeader()
            )
            dispatch({type: API_GET_INVITES_TRAP_SUCCESS})
            return true
        }
        catch (error) {
            const errorCode = idx(error, _ => _.data.status) || ''
            errorDispatcher(errorCode, API_GET_INVITES_TRAP_ERROR, dispatch)
            throw error
        }
    }
}

export function removeUserTrap(trapUserId) {
    return async function dispatcher(dispatch) {
        dispatch({type: API_DELETE_USER_TRAP_REQUEST})
        try {
            await axios.delete(
                `${API_URL}/trap/user/${trapUserId}`,
                getAuthorizationHeader()
            )
            dispatch({type: API_DELETE_USER_TRAP_SUCCESS})
            return true
        }
        catch (error) {
            console.error("removeUserTrap", error)
            const errorCode = idx(error, _ => _.data.status) || ''
            errorDispatcher(errorCode, API_DELETE_USER_TRAP_ERROR, dispatch)
            throw error
        }
    }
}




// WEBPACK FOOTER //
// ./src/modules/trap.js